import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import i18n from "i18next";

import { FormDropDown, FormField } from "../Common";
import { SearchResultsTypes } from "./SearchResults/SearchResultsTypes";
import { required, searchMinLength } from "../../helpers/FormField/formFieldHelpers";
import Button from "../Common/Button";

class AdvancedSearchForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    fields: PropTypes.array,
    periods: PropTypes.array,
    selectedSearchField: PropTypes.string
  };

  static defaultProps = {
    fields: [],
    periods: [],
    selectedSearchField: ""
  };

  state = {
    displayTooltip: false
  };

  get formattedFields() {
    return this.props.fields.map(field => ({ value: field.code, label: field.value }));
  }

  get formattedPeriods() {
    return this.props.periods.map(period => ({ value: period.code, label: period.value }));
  }

  noSearchPeriodFields = [SearchResultsTypes.billsOfLading, SearchResultsTypes.invoice];

  handleMouseEnter = () => this.setState({ displayTooltip: true });

  handleMouseLeave = () => this.setState({ displayTooltip: false });

  handleSearch = values => this.props.onSubmit(values);

  render() {
    const isSearchPeriodDisabled = this.noSearchPeriodFields.includes(this.props.selectedSearchField);
    const displayTooltip = isSearchPeriodDisabled && this.state.displayTooltip;
    return (
      <form name="advanced-search__form" onSubmit={this.props.handleSubmit(this.handleSearch)}>
        <div className="advanced-search__row">
          <Field
            component={FormDropDown}
            data={this.formattedFields}
            name="searchField"
            valueContainerLabel={i18n.t("advancedSearch.field")}
            selectClassName="--large"
            validate={[required]}
          />
          <Field
            component={FormField}
            placeholder={i18n.t("advancedSearch.placeholder")}
            className="advanced-search__fieldset"
            name="searchQuery"
            validate={[required, searchMinLength]}
            icon="search"
          />
          <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
            <Field
              component={FormDropDown}
              data={this.formattedPeriods}
              name="searchPeriod"
              valueContainerLabel={i18n.t("advancedSearch.period")}
              selectClassName="--large"
              disabled={isSearchPeriodDisabled}
              validate={[required]}
            />
            {displayTooltip && <span className="list-popover__content">{i18n.t("advancedSearch.disabledPeriod")}</span>}
          </div>
          <Button className="advanced-search__button" label={i18n.t("advancedSearch.search")} />
        </div>
      </form>
    );
  }
}

export default reduxForm({ form: "advanced-search", enableReinitialize: true })(AdvancedSearchForm);



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/AdvancedSearchForm.js